import { render, staticRenderFns } from "./AdminPlusDrawer.vue?vue&type=template&id=3b88e39a&scoped=true"
import script from "./AdminPlusDrawer.vue?vue&type=script&lang=js"
export * from "./AdminPlusDrawer.vue?vue&type=script&lang=js"
import style0 from "./AdminPlusDrawer.vue?vue&type=style&index=0&id=3b88e39a&prod&scoped=true&lang=css"
import style1 from "./AdminPlusDrawer.vue?vue&type=style&index=1&id=3b88e39a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88e39a",
  null
  
)

export default component.exports